import { getStateCode } from "../../../../../../../constant/states";

// The Practice section itself is now declarative (GenentechFreeDrugFormJson.json). This module is kept
// only for `updateFormFields`, the generic provider -> form mapper still used by the not-yet-declarative
// Prescription and SiteOfTreatment sections; it moves out (or is retired) when those are decomposed.
export const updateFormFields = (entity, mappings, form) => {
  const updates = Object.entries(mappings).reduce((acc, [entityKey, fieldPath]) => {
    // Handle special case for the state field
    const value = entityKey === "state" ? getStateCode(entity[entityKey]) : entity[entityKey];

    // Assuming fieldPath is an array, directly use it for constructing the nested structure
    fieldPath.reduce((current, part, index) => {
      if (index === fieldPath.length - 1) {
        current[part] = value;
        return;
      }
      current[part] = current[part] || {};
      return current[part];
    }, acc);

    return acc;
  }, {});

  form.setFieldsValue(updates);
};
